import React from 'react';

import { useIntercom } from 'react-use-intercom';
import { ViewCommunityIcon, ViewDocsIcon } from 'src/components/icons/GetStarted';
import { IntercomTour } from 'src/config';
import { Apollo } from 'src/gql/generated';

import { GenericAction } from '../StepAccordion';

export function AlineIntroVideo({ task }: { task: Apollo.OnboardingTask }) {
  const { startTour } = useIntercom();
  const [updatedOnboardingTask, { loading: updatingTask }] =
    Apollo.useUpdateOnboardingTaskMutation();

  return (
    <GenericAction
      actionTitle="Run Tour"
      loading={updatingTask}
      text="Welcome to Aline! Get introduced to everything you can achieve with Aline with our tour."
      onClick={async () => {
        startTour(IntercomTour.alineOverview);
        if (!task.completedAt) {
          await updatedOnboardingTask({
            variables: {
              input: { props: { completedAt: new Date().toISOString() }, taskId: task.id },
            },
          });
        }
      }}
    />
  );
}

export function UploadDocumentsTour({ task }: { task: Apollo.OnboardingTask }) {
  const { startTour } = useIntercom();
  const [updatedOnboardingTask] = Apollo.useUpdateOnboardingTaskMutation();

  return (
    <GenericAction
      actionTitle="Upload Documents"
      image={<ViewDocsIcon />}
      text="Upload documents into your repository.  Aline AI will automatically extract key data from the documents and organize them in your repository."
      onClick={async () => {
        startTour(IntercomTour.uploadDocument);
        if (!task.completedAt) {
          await updatedOnboardingTask({
            variables: {
              input: { props: { completedAt: new Date().toISOString() }, taskId: task.id },
            },
          });
        }
      }}
    />
  );
}

export function ViewReport({ task }: { task: Apollo.OnboardingTask }) {
  const { startTour } = useIntercom();
  const [createExampleReport, { loading: creatingReport }] =
    Apollo.useCreateExampleReportMutation();
  const [updatedOnboardingTask] = Apollo.useUpdateOnboardingTaskMutation();

  const handleViewReport = async () => {
    await createExampleReport();
    if (!task.completedAt) {
      await updatedOnboardingTask({
        variables: {
          input: {
            props: { completedAt: new Date().toISOString() },
            taskId: task.id,
          },
        },
      });
    }
    startTour(IntercomTour.alineAIExampleReport);
  };

  return (
    <GenericAction
      actionTitle="View Report"
      image={<ViewCommunityIcon />}
      loading={creatingReport}
      text="View an AI report and learn how to add your own AI questions. After, you can collaborate with your team to analyze your documents."
      onClick={handleViewReport}
    />
  );
}
